import { Injectable, Inject, PLATFORM_ID, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private translate = inject(TranslateService);
  private platformId = inject(PLATFORM_ID);

  constructor() {
    this.translate.addLangs(['en', 'ar']);
    this.translate.setDefaultLang('en');

    const savedLang = isPlatformBrowser(this.platformId) ? localStorage.getItem('langBtakkaBus') : 'en';
    const lang = savedLang || 'en';
    this.setLanguage(lang);
  }

  setLanguage(lang: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('langBtakkaBus', lang);
    }
    this.translate.use(lang).subscribe(() => {
      if (isPlatformBrowser(this.platformId)) {
        const dir = lang === 'ar' ? 'rtl' : 'ltr';

        document.documentElement.lang = lang;
        document.documentElement.dir = dir;

        document.documentElement.setAttribute('data-layout', lang === 'ar' ? 'rtl' : 'default');

        if (lang === 'ar') {
          document.body.classList.add('rtl');
          document.body.dir = 'rtl';
        } else {
          document.body.classList.remove('rtl');
          document.body.dir = 'ltr';
        }

        window.dispatchEvent(new Event('resize'));
      }
    });
  }

  getCurrentLanguage() {
    return this.translate.currentLang || 'ar';
  }
}
